import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import AddButton from "../../buttons/button";
import CloseIcon from "../../../assets/icons/close-icon";
import { useFormikContext } from "formik";
import { useDispatch } from "react-redux";

import { useNavigate } from "react-router-dom";
import { truncateString } from "../../helper-components/helper-function";
import { goodsCrDBNotesAction } from "../../../redux/actions/purchase-action";
import moment from "moment";
import LoadingSpinner from "../../helper-components/loading-spinner";

export default function PurchaseCreditNotePanel({ open, setOpen, page = "" }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (open && page !== "view") {
      setLoading(true);
      dispatch(goodsCrDBNotesAction(values?.cmr_id, onSuccess, onError));
    }
  }, [open]);

  const onSuccess = (data) => {
    setLoading(false);
    const creditNoteData = data?.data?.creditNoteData?.map((item) => ({
      ...item,
      isChecked: false,
    }));
    const creditNoteHeaderData = data?.data?.headerdata;
    setFieldValue(`creditNoteData`, creditNoteData);
    setFieldValue(`claimed_adjusted`, creditNoteHeaderData?.claimed_adjusted);
    setFieldValue(`ledger_closing`, creditNoteHeaderData?.ledger_closing);
    setFieldValue(`pcn_net_balance`, creditNoteHeaderData?.pcn_net_balance);
    setFieldValue(`pcns_total`, creditNoteHeaderData?.pcns_total);
    setFieldValue(`remaining_balance`, creditNoteHeaderData?.remaining_balance);
  };
  const onError = (data) => {
    setLoading(false);
    setFieldValue(`creditNoteData`, []);
  };

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-50"
        onClose={() => {
          setOpen(false);
        }}
      >
        <div className="fixed inset-0 overflow-hidden">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="absolute inset-0 bg-[#0000004D]" />
          </Transition.Child>

          <div className="fixed inset-0 flex justify-end">
            <Transition.Child
              as={Fragment}
              enter="transform transition ease-in-out duration-300"
              enterFrom="translate-x-full"
              enterTo="translate-x-0"
              leave="transform transition ease-in-out duration-300"
              leaveFrom="translate-x-0"
              leaveTo="translate-x-full"
            >
              <Dialog.Panel className="h-full w-[400px] sm:w-[70%] bg-white overflow-y-auto rounded-tl-lg rounded-bl-lg shadow-xl">
                <div
                  className="h-[61px] bg-[var(--slide-panel-head-bg)] px-3 flex items-center justify-between border-b"
                  style={{ borderColor: "var(--slide-panel-border)" }}
                >
                  <div
                    style={{
                      maxHeight: "32px",
                      color: "var(--slide-panel-h-fg)",
                      fontSize: "var(--slide-panel-h-fs)",
                      fontWeight: "var(--slide-panel-h-fw)",
                    }}
                    className="min-w-[75%] "
                  >
                    Cr/Db Notes{" "}
                  </div>
                  <AddButton
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    icon={
                      <CloseIcon
                        width="12px"
                        height="12px"
                        fill="var(--close-button-fg)"
                      />
                    }
                    text={
                      <span>
                        Close <span className="opacity-50">(X)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />
                </div>

                {loading ? (
                  <LoadingSpinner />
                ) : (
                  <div
                    className="px-3 "
                    style={{
                      maxHeight: `calc(100% - 135px)`,
                      minHeight: `calc(100% - 135px)`,
                      height: `calc(100% - 135px)`,
                    }}
                  >
                    <div className="flex items-center justify-between bg-[var(--slide-panel-stats-bg)] rounded-[4px] min-h-[34px] px-4 mt-[20px]">
                      <div className="flex items-center gap-2">
                        <div>
                          <span className="text-[var(--slide-panel-stats-label)] text-[length:var(--slide-panel-stats-label-fs)] font-[var(--slide-panel-stats-label-fw)]">
                            Vendor Payable (Dr):
                          </span>
                          <span className="ml-1 text-[var(--slide-panel-stats-value)] text-[length:var(--slide-panel-stats-value-fs)] font-[var(--slide-panel-stats-value-fw)]">
                            ₹{values?.remaining_balance} Dr
                          </span>
                        </div>
                      </div>

                      <div>
                        <span className="text-[var(--slide-panel-stats-label)] text-[length:var(--slide-panel-stats-label-fs)] font-[var(--slide-panel-stats-label-fw)]">
                          PCNs Total (Cr):
                        </span>
                        <span className="ml-1 text-[var(--slide-panel-stats-value)] text-[length:var(--slide-panel-stats-value-fs)] font-[var(--slide-panel-stats-value-fw)]">
                          ₹{values?.pcns_total}Cr
                        </span>
                      </div>

                      <div>
                        <span className="text-[var(--slide-panel-stats-label)] text-[length:var(--slide-panel-stats-label-fs)] font-[var(--slide-panel-stats-label-fw)]">
                          PCNs Claimed (Cr):
                        </span>
                        <span className="ml-1 text-[var(--slide-panel-stats-value)] text-[length:var(--slide-panel-stats-value-fs)] font-[var(--slide-panel-stats-value-fw)]">
                          ₹{values?.claimed_adjusted} Cr
                        </span>
                      </div>

                      <div>
                        <span className="text-[var(--slide-panel-stats-label)] text-[length:var(--slide-panel-stats-label-fs)] font-[var(--slide-panel-stats-label-fw)]">
                          PCN Net Balance (Cr):
                        </span>
                        <span className="ml-1 text-[var(--slide-panel-stats-value)] text-[length:var(--slide-panel-stats-value-fs)] font-[var(--slide-panel-stats-value-fw)]">
                          ₹{values?.pcn_net_balance} Cr
                        </span>
                      </div>
                      <div>
                        <span className="text-[var(--slide-panel-stats-label)] text-[length:var(--slide-panel-stats-label-fs)] font-[var(--slide-panel-stats-label-fw)]">
                          Ledger Closing Balance (Dr/Cr)
                        </span>
                        <span className="ml-1 text-[var(--slide-panel-stats-value)] text-[length:var(--slide-panel-stats-value-fs)] font-[var(--slide-panel-stats-value-fw)]">
                          ₹{values?.ledger_closing}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        height: `calc(100% - 65px)`,
                        maxHeight: `calc(100% - 65px)`,
                        minHeight: `5rem`,
                      }}
                      className="tab-container rounded-[8px] mt-[20px]"
                    >
                      <table className="w-full border-collapse mt-0">
                        <thead className="sticky top-0 bg-[var(--create-table-header-bg)] z-[10]">
                          <tr className="relative h-[50px] rounded-lg">
                            {heading
                              .filter((col) => col.enabled !== false)
                              .map((col, idx) => (
                                <th
                                  style={{ minWidth: `${col?.minWidth}px` }}
                                  key={idx}
                                  className="px-[8px] whitespace-nowrap text-[var(--create-table-header-fg)] text-[length:var(--create-table-header-fs)] font-[var(--create-table-header-fw)]"
                                >
                                  {col?.value === "action" ? (
                                    <input
                                      type="checkbox"
                                      checked={
                                        values?.creditNoteData?.length > 0 &&
                                        values.creditNoteData.every(
                                          (item) => item.isChecked
                                        )
                                      }
                                      onChange={(e) => {
                                        const isChecked = e.target.checked;
                                        const updatedData =
                                          values.creditNoteData.map((item) => ({
                                            ...item,
                                            isChecked: isChecked,
                                          }));
                                        setFieldValue(
                                          "creditNoteData",
                                          updatedData
                                        );
                                      }}
                                      className="custom-checkbox form-check-input"
                                    />
                                  ) : (
                                    <div
                                      className="flex items-center gap-2 w-full text-wrap"
                                      style={{
                                        justifyContent:
                                          col?.alignment === "right"
                                            ? "flex-end"
                                            : col?.alignment === "center"
                                            ? "center"
                                            : "flex-start",
                                      }}
                                    >
                                      {col?.label}
                                    </div>
                                  )}
                                </th>
                              ))}
                          </tr>
                        </thead>
                        <tbody>
                          {values.creditNoteData?.length > 0 ? (
                            <>
                              {" "}
                              {values.creditNoteData?.map((rowData, index) => (
                                <tr
                                  key={index}
                                  className={`cursor-pointer transition-all  ${
                                    index % 2 === 0
                                      ? " bg-[var(--create-table-row-alt-bg)]"
                                      : " bg-[var(--create-table-row-bg)]"
                                  }   h-[48px]`}
                                >
                                  {heading
                                    .filter((col) => col.enabled !== false)
                                    .map((col, colIndex) => (
                                      <td
                                        style={{
                                          minWidth: `${col?.minWidth}px`,
                                          textAlign: col?.alignment, // Keep textAlign for normal text cells
                                        }}
                                        key={colIndex}
                                        className="border-b border-[var(--create-table-border)] px-[8px] text-left text-[length:var(--create-table-row-font-size)] font-[var(--create-table-row-font-weight)]  whitespace-nowrap cursor-pointer"
                                      >
                                        {col?.value === "action" ? (
                                          <input
                                            type="checkbox"
                                            id={rowData?.item_id}
                                            checked={
                                              rowData?.isChecked || false
                                            }
                                            onChange={(e) => {
                                              const updatedData = [
                                                ...values.creditNoteData,
                                              ];
                                              updatedData[index] = {
                                                ...updatedData[index],
                                                isChecked: e.target.checked,
                                              };
                                              setFieldValue(
                                                "creditNoteData",
                                                updatedData
                                              );
                                            }}
                                            className="custom-checkbox form-check-input"
                                          />
                                        ) : col?.value === "invoice_date" ? (
                                          moment(rowData[col.value]).format(
                                            "YYYY-MM-DD"
                                          )
                                        ) : col?.value === "adjusted_amount" ? (
                                          <input
                                            disabled={page === "view"}
                                            type="number"
                                            value={
                                              rowData.adjusted_amount || ""
                                            }
                                            className="min-h-[33px] px-2 border border-[var(--pay-met-input-border)] focus:outline-none bg-[var(--pay-met-input-bg)] text-[var(--pay-met-val-color)] text-[length:var(--pay-met-val-fs)] font-[var(--pay-met-val-fw)] border-radius input-field-no-spin-buttons w-[6rem] max-w-fit"
                                            onChange={(e) => {
                                              const newValue = parseFloat(
                                                e.target.value
                                              );
                                              const updatedValue = isNaN(
                                                newValue
                                              )
                                                ? ""
                                                : Math.min(
                                                    newValue,
                                                    rowData.remaining_amount
                                                  );

                                              // Update Formik state here — assuming setFieldValue and values are in scope
                                              const updatedCreditNoteData = [
                                                ...values.creditNoteData,
                                              ];
                                              updatedCreditNoteData[
                                                index
                                              ].adjusted_amount = updatedValue;
                                              setFieldValue(
                                                "creditNoteData",
                                                updatedCreditNoteData
                                              );
                                            }}
                                          />
                                        ) : col?.value === "remarks" ? (
                                          <textarea
                                            disabled={page === "view"}
                                            type="text"
                                            value={rowData.remarks || ""}
                                            onChange={(e) => {
                                              const updatedCreditNoteData = [
                                                ...values.creditNoteData,
                                              ];
                                              updatedCreditNoteData[
                                                index
                                              ].remarks = e.target.value;
                                              setFieldValue(
                                                "creditNoteData",
                                                updatedCreditNoteData
                                              );
                                            }}
                                            className=" px-2 py-[1px] border border-[var(--pay-met-input-border)] focus:outline-none bg-[var(--pay-met-input-bg)] text-[var(--pay-met-val-color)] text-[length:var(--pay-met-val-fs)] font-[var(--pay-met-val-fw)] border-radius input-field-no-spin-buttons w-[8rem] max-w-fit"
                                          />
                                        ) : (
                                          truncateString(
                                            rowData[col.value] || "",
                                            100
                                          )
                                        )}
                                      </td>
                                    ))}
                                </tr>
                              ))}
                            </>
                          ) : (
                            <tr>
                              <td
                                colSpan={
                                  heading?.filter((h) => h?.enabled !== false)
                                    ?.length
                                }
                                className="text-center py-4 text-[length:var(--tab-empty-comp-fs)] border-b border-[var(--create-table-border)] font-[var(--tab-empty-comp-fw)] text-[var(--tab-empty-comp-fg)]"
                              >
                                No Data Found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                <div className="flex justify-between h-[50px] items-center px-3">
                  <AddButton
                    prefixIcon={false}
                    onclkFn={() => {
                      setOpen(false);
                    }}
                    text={
                      <span>
                        Cancel <span className="opacity-50">(C)</span>{" "}
                      </span>
                    }
                    className="flex h-[32px]  items-center gap-2 bg-[var(--close-button-bg)] border-radius px-3 text-[var(--close-button-fg)]"
                  />

                  {page !== "view" && (
                    <AddButton
                      onclkFn={() => {
                        setOpen(false);
                      }}
                      prefixIcon={false}
                      text={
                        <span>
                          Adjust Invoice <span className="opacity-50">(A)</span>{" "}
                        </span>
                      }
                      className="
flex items-center px-[30px] h-[44px] whitespace-nowrap rounded-md gap-[8px]
bg-[var(--primary-button-bg-color)] cursor-pointer
text-[var(--primary-button-fg-color)]
border border-[var(--primary-button-bg-color)]
hover:bg-[var(--primary-button-hover-color)]
text-[length:var(--primary-button-create-fs)] 
font-[var(--primary-button-font-weight)]
"
                      type="submit"
                    />
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}

const heading = [
  {
    label: "",
    value: "action",
  },
  { label: "Purchase Invoice Number", value: "invoice_number" },
  { label: "Date", value: "invoice_date" },
  { label: "PCN Amount", value: "invoice_total_amount" },
  { label: "Claimed (Adjusted)", value: "claimed_amount" },
  { label: "Remaining Balance", value: "remaining_amount" },
  { label: "Amt Adjust (input)", value: "adjusted_amount" },
  { label: "Remarks", value: "remarks" },
];
